import AutoGrid from 'components/Layout/AutoGrid';

export const LearningsList = ({ children }: { children?: any }) => (
  <AutoGrid minSize="20rem">{children}</AutoGrid>
);

export default LearningsList;
